export const fileToBase64 = (file) => new Promise((resolve, reject) => {
    const image = file;
    if (!(file instanceof File)) return false;
    if (image && FileReader) {
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    }
});